import { motion } from 'framer-motion';

const Card = ({ title, description, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    whileHover={{ scale: 1.02, boxShadow: '0 8px 16px rgba(0,0,0,0.1)' }}
    className="p-6 bg-white rounded-lg border border-blue-100 shadow-md hover:shadow-lg transition-shadow duration-300"
  >
    <h3 className="text-lg font-semibold text-blue-900 mb-2">{title}</h3>
    <p className="text-blue-700 text-sm leading-relaxed">{description}</p>
  </motion.div>
);

const AboutSection = () => (
  <section className="max-w-5xl mx-auto px-6 py-16 text-center">
    <motion.h2
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="text-3xl md:text-4xl font-bold mb-8 text-blue-900"
    >
      About the Program
    </motion.h2>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.2, ease: 'easeOut' }}
      className="p-6 bg-blue-50 rounded-lg shadow-sm mb-12"
    >
      <p className="text-blue-800 text-lg md:text-xl leading-relaxed tracking-wide">
        The <span className="font-semibold text-blue-600">INSA National Ethio Cyber Talent Summer Camp</span> is your gateway to becoming Ethiopia's next tech leader. Dive into tracks like{' '}
        <span className="text-blue-500 font-medium">cybersecurity</span>,{' '}
        <span className="text-blue-500 font-medium">development</span>,{' '}
        <span className="text-blue-500 font-medium">embedded systems</span>, and{' '}
        <span className="text-blue-500 font-medium">aerospace</span>. Learn from pros, tackle real-world projects, and build skills that shine.
      </p>
    </motion.div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card
        title="Our Goals"
        description="Empower young Ethiopians with cutting-edge tech skills, foster innovation, and build a strong foundation for national technological advancement."
        delay={0.4}
      />
      <Card
        title="Our Values"
        description="Integrity, excellence, and collaboration drive us to create an inclusive environment where creativity and learning thrive."
        delay={0.6}
      />
    </div>
  </section>
);

export default AboutSection;